export default __webpack_public_path__ + "static/media/0x2bf9b864cdc97b08b6d79ad4663e71b8ab65c45c.936dd8e7.png";